<template>
  <div class="wrapper">
    <div class="card">
      <div v-if="$slots.title" class="card_header">
        <!-- @slot Title of card -->
        <slot v-if="$slots.title" name="title" />

        <!-- @slot Slot for `more` button popover -->
        <slot v-if="$slots.more" name="more" />
      </div>

      <div v-if="$slots.content" class="card_content">
        <!-- @slot Main content of card -->
        <slot name="content" />
      </div>

      <div v-if="$slots.footer" class="card_footer">
        <!-- @slot Footer content of card -->
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
/*
  Content block
*/
export default {}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  padding: rem(16px);
  background: $color-gray-10;
}

.card {
  padding: rem(20px);
  background: $white;

  @include border_radius(5px);
  @include box-shadow(0 1px 15px 0 rgba(0, 0, 0, 0.08));

  &_header {
    padding: 0 0 rem(20px) 0;
    font-weight: bold;
    border-bottom: 1px solid $color-gray-25;

    @include createFlex(flexbox, nowrap, row, space-between, center, center);

    .title {
      font-size: rem(14px);
      color: $color-gray-600;

      @include createFlex(flexbox, nowrap, row, flex-start, center, center);

      &_value {
        margin: 0 0 0 5px;
        color: $color-gray-500;
      }
    }

    .more {
      margin: 0 -10px 0 0;
    }
  }
  &_content {
    padding: rem(20px) 0;

    &_line {
      &:not(:last-child) {
        margin: 0 0 rem(20px) 0;
      }
    }
  }
  &_footer {
    padding: rem(20px) 0 0 0;
    border-top: 1px solid $color-gray-25;
  }

  &-full-height {
    height: 100%;
  }
}
</style>

<docs>
Basic UiCard example:
```vue
<UiCard>
  <div slot="title">
    <div class="title">Title </div>
  </div>

  <div slot="content"> Content </div>

  <div slot="footer">
    Footer content
  </div>
</UiCard>
```

With UiCardContentLine component UiCard example:
```vue
<template>
  <UiCard>
    <div slot="title">
      <div class="title">Title </div>
    </div>

    <div slot="content">
      <UiCardContentLine class="card_content_line">
        <span slot="title">Создание карты</span>
        <span slot="value">0,00 ₽</span>
      </UiCardContentLine>
    </div>

    <div slot="footer">
      Footer content
    </div>
  </UiCard>
</template>

<script>
import UiCardContentLine from '@/components/card/UiCardContentLine.vue'
export default {
  components: {UiCardContentLine}
}
</script>
```
</docs>
